import { Injectable } from '@angular/core';
import { GeneralConstants } from '../constants/general.constants';
import { RestService } from './rest.service';
import { NotificationService } from './notification.service';
import { QueryModel } from '../models/query.model';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BaseResponseClass } from '../classes/base-response.class';
import { QueriesModel } from '../models/queries.model';

@Injectable({
  providedIn: 'root'
})
export class SendHelpService {
  constructor(
    private restService: RestService,
    private notificationService: NotificationService,
    public http: HttpClient
  ) {}

  /**
   *
   * @returns Devuelve los motivos de reclamo obtenidos desde nova
   */
  public getReasons = async () => {
    try {
      const response = await this.restService.get(GeneralConstants.getReasons);
      return response;
    } catch (e) {
      this.notificationService.mgsView({
        error: null,
        messenger: 'No pudimos traer los motivos de consulta, por favor intentá en unos minutos.',
        title: '',
        type: 2,
        configNotification: null
      });
    }
  };

  /**
   *
   * @returns Devuelve las consultas realizadas por el usuario logueado
   */
  public getQueries = async () => {
    try {
      const response = await this.restService.get(GeneralConstants.getQueries);
      let consultas = response.listOfResults.listOfResult.filter((el) => el.respuestaId == '0');
      let respuestas = response.listOfResults.listOfResult.filter((el) => el.respuestaId !== '0');
      let motivos = await this.getReasons();
      let collection = new Array<QueriesModel>();

      for (let item of consultas) {
        let queryItem = new QueriesModel();
        let fecha = [];
        respuestas.filter((el) => (el.respuestaId == item.id ? fecha.unshift(el) : null));
        queryItem.id = item.id;
        queryItem.comentario = item.comentario;
        queryItem.estadoConsulta = item.estadoConsulta;
        queryItem.fecha = fecha.length > 0 ? new Date(fecha[0].fecha) : new Date(item.fecha);
        queryItem.motivoId = item.motivoId;
        queryItem.respuestaId = item.respuestaId;
        queryItem.nombreOperador = item.nombreOperador;
        queryItem.motivo = item.motivoId
          ? motivos.listOfResults.listOfResult.filter(
              (el) => queryItem.motivoId.toString() === el.motivoId.toString()
            )[0].descripcion
          : '';

        collection.unshift(queryItem);
      }
      collection.sort((a: any, b: any) => {
        if (a.fecha > b.fecha) {
          return -1;
        }
        if (a.fecha < b.fecha) {
          return 1;
        }
      });
      return [collection, respuestas];
    } catch (e) {
      console.log(e);
      this.notificationService.mgsView({
        error: null,
        messenger: 'Ocurrió un error al traer sus consultas, por favor intentá en unos minutos.',
        title: '',
        type: 2,
        configNotification: null
      });
    }
  };

  public getAnswers = async () => {
    let answers = await this.getQueries();
    return answers[1];
  };

  /**
   *
   * @param query Recibe una consulta de tipo QueryModel con motivoId: number, descripcion: string, respuestaId: number, archivo: File
   */
  public sendQuery = async (query: QueryModel, exist?: boolean) => {
    try {
      let formData: FormData = new FormData();
      formData.append('descripcion', query.descripcion);
      formData.append('motivoId', query.motivoId.toString());
      formData.append('respuestaId', query.respuestaId ? query.respuestaId.toString() : '0');
      formData.append('nombreOperador', 'yacareproductivo');
      formData.append('archivo', query.archivo ? query.archivo : null);

      let response = await this.restService.postConsulta(GeneralConstants.sendQuery, formData);

      this.notificationService.mgsView({
        error: null,
        messenger: 'Estamos trabajando en tu inconveniente, en breves te daremos una respuesta.',
        title: 'Consulta enviada',
        type: 1,
        configNotification: null
      });
    } catch (e) {
      console.log(e);
      this.notificationService.mgsView({
        error: null,
        messenger: 'Ocurrió un error al enviar la consulta, por favor intentá en unos minutos.',
        title: '',
        type: 2,
        configNotification: null
      });
    }
  };
}
